function RakebackCalc(element) {
    const self = this;
    const container = element // Суть в том что на странице теоретически может быть несколько калькуляторов с разными данными.
    const data = JSON.parse(container.getAttribute('data-json'))
    const dataRakeback = JSON.parse(container.getAttribute('data-rakeback'))
    let rake_percent = dataRakeback.rakeback_list.find(item => item.is_default).value;
    // console.log(data);

    this.init = function () {
        console.log('calc init');
        // console.log('INIT RANGE', rake_percent);
        this.dropdowns.init();
        this.range.init();
        this.calculator.init();
    }

    this.range = {
        init() {
            this.rangeHandler()
            this.fillTrack()
            const loadValue = container.querySelector('[data-rakeback-range]').value;
            self.calculator.doMath_range(loadValue);
        },
        rangeHandler() {
            const inputRange = container.querySelector('[data-rakeback-range]')
            if (inputRange) {
                inputRange.addEventListener('input', (e) => {
                    this.fillTrack();
                    self.calculator.doMath_range(e.target.value);
                })
            }
        },
        fillTrack() {
            const inputRange = container.querySelector('[data-rakeback-range]')
            const inputRangeTrack = container.querySelector('[data-rakeback-range-track]')
            if (inputRangeTrack && inputRange) {
                const inputMaxValue = inputRange.getAttribute('max')
                const step = 1000
                const roundedValue = Math.round(inputRange.value / step) * step
                const percent = Math.trunc(roundedValue / inputMaxValue * 100)
                inputRange.value = roundedValue
                
                inputRangeTrack.after(" ");
                inputRangeTrack.style.background = `linear-gradient(90deg, #58A3CD 0%, #55CDA2 100%)`
                inputRangeTrack.style.backgroundSize = `${percent}%`
                inputRangeTrack.style.backgroundRepeat = `no-repeat`

            }
        }
    }

    this.dropdowns = {
        init() {
            const title_list = Object.keys(data).map(key => ({
                id: key,
                title: data[key].title,
                option: data[key].hand_time
            }));
            const select_title_first = Object.values(data)[0].title;
            const first_nl_list = Object.values(data)[0].loss_rates.map(rate => ({
                id: 0,
                title: rate.title,
                option: rate.loss_rate,
                limit: rate.limit
            }));

            const rakebackList = dataRakeback.rakeback_list;
            const defaultRakeback = dataRakeback.rakeback_list.find(item => item.is_default);
            
            this.draw_select("calcRakebackTitles", select_title_first, title_list, 1, 'title');
            this.draw_select("calcRakebackNL", first_nl_list[7].title, first_nl_list, 2, 'nl');
            this.draw_select("calcRakebackRange", defaultRakeback.title, rakebackList, 3, 'rake');
            $(document).on('click', '.dropdown__select-option[data-val]', (e) => {
                let list_id = e.target.dataset.val;
                let nl_title_list = data[list_id].loss_rates.map(rate => ({
                    id: list_id,
                    title: rate.title,
                    option: rate.loss_rate,
                    limit: rate.limit
                }));
                this.draw_select("calcRakebackNL", nl_title_list[7].title, nl_title_list, 2, 'nl');
                self.calculator.recalc();
            });
        },
        bind_actions() {
            const dropdowns = container.querySelectorAll('.dropdown');
            dropdowns.forEach((dropdown) => {
                const label = dropdown.querySelector('.dropdown__filter-selected');
                const options = Array.from(dropdown.querySelectorAll('.dropdown__select-option'));
                const toggle = dropdown.querySelector('.dropdown__switch');

                options.forEach((option) => {
                    option.addEventListener('click', () => {
                        options.forEach((o) => {
                            o.classList.remove('_active');
                        });
                        label.textContent = option.textContent;
                        Object.keys(option.dataset).forEach(key => {
                            label.dataset[key] = option.dataset[key];
                        });
                        option.classList.add('_active');
                        self.calculator.recalc();
                    });
                });

                container.addEventListener('click', (e) => {
                    const toggle = dropdown.querySelector('.dropdown__switch');
                    const element = e.target;
                    if (element == toggle) return;
                    const isDropdownChild = element.closest('.dropdown');
                    if (!isDropdownChild) {
                        toggle.checked = false;
                    }
                }, {once: true});
            });

            const dropdownRake = container.querySelector('#calcRakebackRange');
            dropdownRake.querySelectorAll('.dropdown__select-option').forEach((option) => {
                option.addEventListener('click', () => {
                    rake_percent = option.dataset.rake;
                    self.calculator.recalc();
                })
            })
        },

        draw_select(jselector_id, select_title_first, title_list, id, type) {
            let html = this.get_select_html.apply(this, [select_title_first, title_list, id, type])
            container.querySelector('#' + jselector_id).innerHTML = html;
            this.bind_actions();
        },

        get_select_html(select_title_first, title_list, id, type) {
            const switchId = `filter-switch${id}`;
            const dropdownId = `dropdown${id}`;
            let dataValFirstAttr = (type === 'title') ? `data-val="${title_list[0].id}" data-option="${title_list[0].option}"` :
                (type === 'nl') ? `data-nl-limit="${title_list[7].option}" data-nl-size="${title_list[7].limit}"` :
                '';
            const select_inner = title_list.map((item, index) => {
                let dataValAttr = (type === 'title') ? `data-val="${item.id}" data-option="${item.option}"` :
                    (type === 'nl') ? `data-nl-limit="${item.option}" data-nl-size="${item.limit}"` :
                    (type === 'rake') ? `data-rake="${item.value}"` :
                    '';
                    let extraClass = index === 7 ? ' _active' : '';
                return `<li class="dropdown__select-option${extraClass}" ${dataValAttr} role="option">${item.title}</li>`;
            }).join('');
            return `
                <div class="dropdown" id="${dropdownId}">
                    <input class="dropdown__switch" id="${switchId}" type="checkbox" hidden="">
                    <label class="dropdown__options-filter" for="${switchId}">
                        <ul class="dropdown__filter" role="listbox" tabindex="-1">
                            <li class="dropdown__filter-selected" ${dataValFirstAttr} aria-selected="true">${select_title_first}</li>
                            <li>
                                <ul class="dropdown__select">
                                    ${select_inner}
                                </ul>
                            </li>
                        </ul>
                    </label>
                </div>`
        }
    }
    this.calculator = {
        // rake_percent: range_dropdown_value,
        button: container.querySelector('#inputSubmit'),
        inputHours: container.querySelector('#inputHours'),
        inputTabels: container.querySelector('#inputTables'),
        init() {
            const radioButtons = document.querySelectorAll('#rakeDuration input[type="radio"]');
            radioButtons.forEach((radio) => {
                radio.addEventListener('change', () => {
                    this.recalc();
                });
            });
            const tabsRadios = document.querySelectorAll('.calculator-rakeback-tabs-wrapper input[type="radio"]');
            tabsRadios.forEach((radio) => {
                radio.addEventListener('change', () => {
                    this.recalc();
                })
            })
            this.button.addEventListener('click', () => {
                let hours = this.inputHours.value
                let tabels = this.inputTabels.value
                self.calculator.doMath_inputs(hours, tabels)
            })
        },
        recalc() {
            const radioInputChecked = document.querySelector('.calculator-rakeback-tabs-wrapper input[type="radio"]:checked');
            if (radioInputChecked) {
                if (radioInputChecked.id === 'quantity-of-hands') {
                    const range_value = container.querySelector('[data-rakeback-range]').value;
                    this.doMath_range(range_value);
                  } else if (radioInputChecked.id === 'quantity-of-hours') {
                    let hours = this.inputHours.value
                    let tabels = this.inputTabels.value
                    self.calculator.doMath_inputs(hours, tabels)
                  }
            }
        },
        round_and_format(number) {
            return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        },
        doMath_range(range_value) {
            // сцапаем все необходимые нам переменные:
            const loss_rate = container.querySelector('#calcRakebackNL').querySelector('.dropdown__filter-selected').getAttribute('data-nl-limit'),
                limit = container.querySelector('#calcRakebackNL').querySelector('.dropdown__filter-selected').getAttribute('data-nl-size')
            const price_of_one_hand = ((loss_rate / 100) * (limit / 100))
            container.querySelector('#hands_total_tab_1').innerText = this.round_and_format(range_value);

            const newVal = Number(((range_value) * 100) / (200000));
            container.querySelector('#hands_total_tab_1').style.left  = `calc(${newVal}% + (${8 - newVal * 0.8}px))`;

            const time_correction = this.checkRadios();
            const total = price_of_one_hand * range_value * rake_percent * time_correction
            const total_rounded = this.round_and_format(total);
            container.querySelector('#calcRakebackTotal').innerText = total_rounded;
        },
        doMath_inputs(input_1, input_2) {
            const loss_rate = container.querySelector('#calcRakebackNL').querySelector('.dropdown__filter-selected').getAttribute('data-nl-limit'),
            limit = container.querySelector('#calcRakebackNL').querySelector('.dropdown__filter-selected').getAttribute('data-nl-size'),
            hand_time = container.querySelector('#calcRakebackTitles').querySelector('.dropdown__filter-selected').getAttribute('data-option')

            const hands_per_month = (input_1 * 3600 * input_2 * 30) / hand_time;
            container.querySelector('#hands_total_tab_2').innerText = this.round_and_format(hands_per_month);
            const price_of_one_hand = ((loss_rate / 100) * (limit / 100));
            const time_correction = this.checkRadios();
            const total = hands_per_month * price_of_one_hand * rake_percent * time_correction;
            const total_rounded = this.round_and_format(total);
            container.querySelector('#calcRakebackTotal').innerText = total_rounded;
        },
        checkRadios() {
            const checkedRadio = container.querySelector('#rakeDuration input[type="radio"]:checked');
            if (checkedRadio) {
                return parseFloat(checkedRadio.dataset.duration);
            }
            return null;
        }
    }
}
if (document.getElementById("rakeBackCalc-1")) {
    const calc = new RakebackCalc(document.getElementById("rakeBackCalc-1"))
    calc.init()
}

function createslider(element) {
    const inputs = element.querySelectorAll('input');

    const thumbLeft = element.querySelector('.thumb.left');
    const thumbRight = element.querySelector('.thumb.right');
    const rangeBetween = element.querySelector('.range-between');
    const labelMin = element.querySelector('.range-label-start');
    const labelMax = element.querySelector('.range-label-end');
    const randomButton = element.querySelector('.randomizer-button');
    const randomTextSelector = element.querySelector('#number');

    const [inputStart, inputEnd] = inputs;

    setStartValueCustomSlider(inputStart, inputEnd, thumbLeft, rangeBetween);
    setEndValueCustomSlider(inputEnd, inputStart, thumbRight, rangeBetween);
    
    setEvents(inputStart, inputEnd, thumbLeft, thumbRight, labelMin, labelMax, rangeBetween, randomButton, randomTextSelector, element);
    switchlogic(element, randomTextSelector, randomButton);
    setLabelValue(labelMin, inputStart);
    setLabelValue(labelMax, inputEnd);
}

function setLabelValue(label, input) {
    label.innerHTML = `${input.value}`;
}

function setStartValueCustomSlider(inputStart, inputEnd, pseudoEl, range) {
    const maximum = Math.min(parseInt(inputStart.value), parseInt(inputEnd.value) - 1);
    const percent = ((maximum - inputStart.min) / (inputStart.max - inputStart.min)) * 100;
    pseudoEl.style.left = percent + '%';
    range.style.left = percent + '%';
}

function setEndValueCustomSlider(inputEnd, inputStart, pseudoEl, range) {
    const minimun = Math.max(parseInt(inputEnd.value), parseInt(inputStart.value) + 1);
    const percent = ((minimun - inputEnd.min) / (inputEnd.max - inputEnd.min)) * 100;
    pseudoEl.style.right = 100 - percent + '%';
    range.style.right = 100 - percent + '%';
}

function generateRandomNumber(element, randomTextSelector) {
    const inputs = element.querySelectorAll('input');
    const [inputStart, inputEnd] = inputs;

    const start = parseInt(inputStart.value);
    const end = parseInt(inputEnd.value);

    const newNumber = Math.floor(Math.random() * (end - start + 1) + start);
    randomTextSelector.innerText = newNumber;
}

function switchlogic(element, randomTextSelector, randomButton) {
    let intervalId;
    let inputInterval = element.querySelector('.randomizer-num-input');

    element.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"]') && e.target.id.startsWith('darkmode')) {
            if (e.target.checked) {
                element.classList.add('dark');
            } else {
                element.classList.remove('dark');
            }
        } else if (e.target.matches('input[type="checkbox"]') && e.target.id.startsWith('timeout')) {
            if (e.target.checked) {
                console.log('timeout start');
                // e.target.closest('.randomizer-control').querySelector('.randomizer-num-input').classList.add('_active');
                if (intervalId) {
                    clearInterval(intervalId);
                }
                let IntervalSec = parseInt(inputInterval.value) * 1000;
                rotateElement(randomButton.querySelector('svg'), IntervalSec);
                intervalId = setInterval(() => {
                    generateRandomNumber(element, randomTextSelector);
                }, IntervalSec);
            } else {
                console.log('timeout end');
                // e.target.closest('.randomizer-control').querySelector('.randomizer-num-input').classList.remove('_active');
                clearInterval(intervalId);
                stopRotateElement(randomButton.querySelector('svg'));
            }
        }
    });
    inputInterval.addEventListener('input', function (e) {
        let v = parseInt(this.value);
        if (v < 1) this.value = 1;
        if (v > 99) this.value = 99;

        if (element.querySelector('input[type="checkbox"]').id.startsWith('timeout') &&
            element.querySelector('input[type="checkbox"]').checked) {
            console.log('timeout start');
            if (intervalId) {
                clearInterval(intervalId);
            }
            let IntervalSec = parseInt(inputInterval.value) * 1000;
            rotateElement(randomButton.querySelector('svg'), IntervalSec);
            intervalId = setInterval(() => {
                generateRandomNumber(element, randomTextSelector);
            }, IntervalSec);
        }
    })
}
function rotateElement(element, duration) {
    element.classList.remove('rotate');
    element.offsetWidth;

    element.style.transform = 'rotate(0)';
    element.classList.add('rotate');
    element.style.animationDuration = `${duration}ms`;
    element.style.animationIterationCount = 'infinite';
}
function stopRotateElement(element) {
    element.classList.remove('rotate');
    element.style.animationDuration = '0.3s';
    element.style.animationIterationCount = '1';

}

function setEvents(
    inputStart,
    inputEnd,
    thumbLeft,
    thumbRight,
    labelMin,
    labelMax,
    rangeBetween,
    randomButton,
    randomTextSelector,
    element
) {

    randomButton.addEventListener('click', () => {
        generateRandomNumber(element, randomTextSelector);
        rotateElement(element.querySelector('.randomizer-button svg'), 300)
        setTimeout(() => {
            stopRotateElement(element.querySelector('.randomizer-button svg'));
        }, 300);
    });
    inputStart.addEventListener('input', () => {
        setStartValueCustomSlider(inputStart, inputEnd, thumbLeft, rangeBetween);
        setLabelValue(labelMin, inputStart);
    });

    inputEnd.addEventListener('input', () => {
        setEndValueCustomSlider(inputEnd, inputStart, thumbRight, rangeBetween);
        setLabelValue(labelMax, inputEnd);
    });

    // add css clases on hover and drag
    inputStart.addEventListener('mouseover', function () {
        thumbLeft.classList.add('hover');
    });
    inputStart.addEventListener('mouseout', function () {
        thumbLeft.classList.remove('hover');
    });
    inputStart.addEventListener('mousedown', function () {
        thumbLeft.classList.add('active');
    });
    inputStart.addEventListener('pointerup', function () {
        thumbLeft.classList.remove('active');
    });

    inputEnd.addEventListener('mouseover', function () {
        thumbRight.classList.add('hover');
    });
    inputEnd.addEventListener('mouseout', function () {
        thumbRight.classList.remove('hover');
    });
    inputEnd.addEventListener('mousedown', function () {
        thumbRight.classList.add('active');
    });
    inputEnd.addEventListener('pointerup', function () {
        thumbRight.classList.remove('active');
    });

    // Mobile
    inputStart.addEventListener('touchstart', function () {
        thumbLeft.classList.add('active');
    });
    inputStart.addEventListener('touchend', function () {
        thumbLeft.classList.remove('active');
    });
    inputEnd.addEventListener('touchstart', function () {
        thumbRight.classList.add('active');
    });
    inputEnd.addEventListener('touchend', function () {
        thumbRight.classList.remove('active');
    });
}

const sliders = document.querySelectorAll(".randomizer");
sliders.forEach((slider) => {
    createslider(slider)
})


const rdmAppPopup = document.querySelector('.open-in-new-tab');
 if (rdmAppPopup) {
     rdmAppPopup.addEventListener('click', (e) => {
         e.preventDefault();
         e.stopPropagation();
         const params = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,width=362,height=362';
     
         if (window.popupWindow) {
             window.popupWindow.close();
         }
         const url = window.location.href + '?popup=1';
         window.popupWindow = window.open(url, "Randomizer", params);
     });
 }